import { Injectable } from '@angular/core';
import {
  UserManagementItem,
  UserManagementTeamName,
  UserManagementUpdateBody,
} from '@app/domain/entities/user-management.entity';
import { UserManagementParams } from '@app/domain/models/user-management.model';
import { UserManagementRepository } from '@app/domain/repositories/user-management.repository';
import { PaginatedResponse } from '@app/shared/models/global.model';
import { Observable } from 'rxjs';
import { UserManagementService } from '../api-clients/user-management.service';

@Injectable()
export class UserManagementRepositoryImpl implements UserManagementRepository {
  constructor(private readonly _userManagementService: UserManagementService) {}

  getUserManagementList(
    params: UserManagementParams
  ): Observable<PaginatedResponse<UserManagementItem>> {
    return this._userManagementService.getUserManagementList(params);
  }

  updateUsers(body: UserManagementUpdateBody): Observable<void> {
    return this._userManagementService.updateUsers(body);
  }

  getTeamNames(): Observable<UserManagementTeamName[]> {
    return this._userManagementService.getTeamNames();
  }

  syncUsers(): Observable<void> {
    return this._userManagementService.syncUsers();
  }
}
